import { render, staticRenderFns } from "./HeadSlots.vue?vue&type=template&id=18d51f6b&scoped=true&"
import script from "./HeadSlots.vue?vue&type=script&lang=js&"
export * from "./HeadSlots.vue?vue&type=script&lang=js&"
import style0 from "./HeadSlots.vue?vue&type=style&index=0&id=18d51f6b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d51f6b",
  null
  
)

export default component.exports